import React, { useMemo } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: 'active' | 'inactive' | 'all';
    setValue: React.Dispatch<React.SetStateAction<'active' | 'inactive' | 'all'>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

export default function PlateStatusDropdown({ value, setValue, labelStyle, viewStyle, zIndex }: Props) {
    const items = useMemo(() => [
        { label: 'all', value: 'all' },
        { label: 'active', value: 'active' },
        { label: 'inactive', value: 'inactive' }
    ].map(situation => {
        return { label: translate(situation.label), value: situation.value };
    }), []);

    return (
        <FilterDropdown
            label={translate('status')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
